import React, { useEffect, useRef, useState } from 'react';
import './Reveal.css';

export default function Reveal({ children, delay = 0, as: Tag = 'div', className = '', ref: externalRef }) {
  const internalRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = internalRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const setRefs = (node) => {
    internalRef.current = node;
    if (typeof externalRef === 'function') externalRef(node);
    else if (externalRef) externalRef.current = node;
  };

  return (
    <Tag
      ref={setRefs}
      className={`tp-reveal${visible ? ' tp-reveal--visible' : ''}${className ? ` ${className}` : ''}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
    >
      {children}
    </Tag>
  );
}
